import React, { useContext } from 'react';
import './WelcomeScreen.css';
import { MasterContext } from '../../../ContextApi/context';
import ConnUrls from '../../../Connections/ConnectURL';
import { Close } from '@mui/icons-material';
import myFunctions from '../../../myFunctions';

/**
 * WelcomeScreen
 *
 * Entry modal offering "registered user" / "new user" login paths.
 *
 * Props:
 * @param {boolean} isOpen        - controls visibility of the modal
 * @param {string} icon           - icon name (ti-* class suffix), default "ice-cream-2"
 * @param {string} title          - heading text, default "ברוכים הבאים"
 * @param {string} description    - body text under the heading
 * @param {string} headerLabel    - label next to the top-right back button, default "התחברות"
 * @param {string} registeredLabel - primary button text, default "משתמש רשום"
 * @param {string} newUserLabel   - secondary button text, default "משתמש חדש"
 * @param {function} onBack       - called when the top-right circular button is clicked
 * @param {function} onRegistered - called when the primary (registered user) button is clicked
 * @param {function} onNewUser    - called when the secondary (new user) button is clicked
isOpen = true,
        icon = 'ice-cream-2',
        title = 'ברוכים הבאים',
        description = 'לאפליקציה המקומית אשדוד בתפריט. אנחנו דואגים שכל מנה תהיה הכי משתלמת בסביבה.',
        headerLabel = 'התחברות',
        registeredLabel = 'משתמש רשום',
        newUserLabel = 'משתמש חדש',
        onBack,
        onRegistered,
        onNewUser,
*/
const WelcomeScreen = (props) => {

    const [master, setMaster] = useContext(MasterContext);

    myFunctions.useEscapeKey(props.isOpen ? props.onBack : null);

    if (!props.isOpen) return null;

    return (
        <div className="ws-backdrop" dir="rtl">
            <div className="ws-card">
                <div className="ws-header" dir="rtl">
                    <button type="button"
                        className="btnReset ws-Close-btn onRight"
                        onClick={props.onBack}
                        aria-label="חזור">
                        <Close aria-hidden="true" style={{ width: '100%', height: '100%' }} />
                    </button>
                    <span className="bold veryBig arrowing fullRow">{props.headerLabel}</span>

                    {/* <button
                        type="button"
                        className="ws-header-btn"
                        onClick={props.onBack}
                        aria-label="חזור"
                    >
                        <i className="ti ti-arrow-left" aria-hidden="true"></i>
                    </button> */}

                </div>

                {/* <div className="ws-icon-wrap"> */}
                    <div className="roundWrap">
                        <img src={`${ConnUrls.servMediasUrl}${master.welcomeImg}`} alt="Welcome" className="ws-logo" />
                        {/* <i className={`ti ti-${props.icon} ws-icon`} aria-hidden="true"></i> */}
                    </div>
                {/* </div> */}

                {/* <h2 className="bold veryBig arrowing noMargin">{props.title}</h2> */}
                <div className={"bold anakMeod arrowing"}>{props.txt1 ? props.txt1 : "ברוכים הבאים"}</div>
                <div className={"big arrowing"}>{props.txt2 ? props.txt2 : "לאפליקציה המקומית אשדוד בתפריט."}</div>
                <div className={"big arrowing"}>{props.txt3 ? props.txt3 : "אנחנו דואגים שכל מנה, תהיה הכי"}</div>
                <div className={"big spaceMargBottomBig arrowing"}>{props.txt4 ? props.txt4 : "משתלמת בסביבה."}</div>

                <button
                    type="button"
                    className="ws-btn ws-btn-primary"
                    onClick={props.onRegistered}
                >
                    {props.registeredLabel}
                </button>
                <button
                    type="button"
                    className="ws-btn ws-btn-secondary"
                    onClick={props.onNewUser}
                >
                    {props.newUserLabel}
                </button>
            </div>
        </div>
    );
}

export default WelcomeScreen;